import React from 'react';

import PropTypes from 'prop-types';

import {
    Lightbox,
    Modal,
    Typography,
    Image,
} from 'wanderu-components';

import styles from './ImageModal.scss';

const propTypes = {
    dismissModal: PropTypes.func,
    image: PropTypes.shape({
        metadata: PropTypes.shape({
            alt: PropTypes.string,
            author: PropTypes.string,
        }),
        url: PropTypes.string,
    }),
};

const defaultProps = {
    dismissModal: () => { },
    image: {},
};

const ImageModal = (props) => {
    const {
        image,
        dismissModal,
    } = props;

    return (
        <Modal>
            <Lightbox
                innerClassName={styles.lightbox}
                onHide={dismissModal}
            >
                <Image
                    alt={image?.metadata?.alt || ''}
                    className={styles.image}
                    src={image.url}
                    title={image?.metadata?.alt || ''}
                />
                {image?.metadata?.alt && (
                    <Typography
                        className={styles.text}
                        variant='body2'
                    >
                        {image.metadata.alt || ''}
                    </Typography>
                )}
                {image?.metadata?.author && (
                    <Typography
                        className={styles.author}
                        variant='body2'
                    >
                        {image.metadata.author || ''}
                    </Typography>
                )}
            </Lightbox>
        </Modal>
    );
};

ImageModal.propTypes = propTypes;
ImageModal.defaultProps = defaultProps;

export default ImageModal;
